import React from 'react'
import { useNavigate } from 'react-router-dom';

function Rules() {
  const Navigate = useNavigate();
  const handleMenu = () => {
      Navigate('/menu');
  }
  return (
    <div id='rules'>
      <div className="exit">

   <h2  onClick={handleMenu}>&#10005;</h2>
      </div>
        <div className='rules'>

        <h1>Ереже - Правила</h1>
        <p>
        <span>Құрметті қонақтар! <br /> </span>

Біз күнделікті сағат 11-00 ден 23-45-ге дейін  жұмыс жасаймыз <br />
Асханадан тапсырыстар 23-00 -ге дейін қабылданады! <br />
Қызымет көрсету 10% <br />
Бірінші және екінші тағамдарды дайындау уақыты:  20-40 минут <br />
Тапсырыстан кейін берілген тағамнан бас тартуға болмайды! <br />
Азық-түлік, тағам және сусындарды әкелуге тыйым салынады! <br />
Мүлікті бүлдірген үшін  2000-30 000 тенгеге дейін  айыппұл салынады!  <br />
Кабинкалар 1000 тенге <br />
Вип бөлмелер 1000 тенге <br />
Біздің мекемеде Спирттік ішімдіктер ішуге тыйым салынған! <br />
Азарттық ойындар ойнауға тыйым салынған!  <br />
<br />
<span>Уважаемые гости! <br />
</span>
Мы рады приветствовать вас в «Шашлык House»МЫ РАБОТАЕМ ЕЖЕДНЕВНО С  11.00 ДО 23.45 <br />
Заказы с кухни принимаются до 23.00 <br />
Обслуживание 10% <br />
Время приготовления первых и вторых блюд от 20 до 30 минут <br />
Отказ от блюд, всех видов напитков после выполнения заказа не принимаются! <br />
Приносить свои закуски, напитки ЗАПРЕЩЕНО! <br />
Штраф 5000 тенге (повторно 10000 тенге) <br />
Уважаемые гости! У нас в карты не играют!!! <br />
За порчу имущества штраф в размере от 2000 до 30000 тенге <br />
Кабинки 1000 тенге <br />
VIP комнаты 1000 тенге <br />
НАШЕ ЗАВЕДЕНИЕ ИМЕЕТ СТАТУС «ХАЛАЛ» <br />
ЗА РАСПИТИЕ СПИРТНЫХ НАПИТКОВ ШТРАФ 50000 ТЕНГЕ <br />
ТАК ЖЕ НЕ РАЗРЕШАЕМ ГРОМКУЮ МУЗЫКУ И ШОУ ПРОГРАММУ
</p>
</div>

</div>

  )
}

export default Rules